<script setup>
import { defineEmits, defineProps } from 'vue'
import BaseCard from "@/pages/UserProfile/integrations/BaseCard.vue";
defineProps({
    user: Object
});
const emit = defineEmits(['open-change-email-modal', 'open-change-password-modal']);
</script>

<template>
    <BaseCard>
        <template #header>
            <h3 class="font-medium text-gray-900 text-base">Настройки аккаунта</h3>
        </template>

        <div class="space-y-6">
            <div class="flex justify-between items-start pb-4 border-b border-gray-100">
                <div>
                    <p class="text-sm font-medium text-gray-700">Email</p>
                    <p class="text-sm text-gray-500 mt-0.5">{{ user.email }}</p>
                </div>
                <button
                    type="button"
                    class="text-blue-600 text-sm hover:underline"
                    @click="emit('open-change-email-modal')"
                >
                    Изменить
                </button>
            </div>

            <div class="flex justify-between items-start">
                <div>
                    <p class="text-sm font-medium text-gray-700">Пароль</p>
                    <p class="text-sm text-gray-500 mt-0.5">Последние изменения: {{ user.passwordUpdatedAt }}</p>
                </div>
                <button
                    type="button"
                    class="text-blue-600 text-sm hover:underline"
                    @click="emit('open-change-password-modal')"
                >
                    Сменить
                </button>
            </div>
        </div>
    </BaseCard>
</template>